import avatar from "assets/img/avatars/dan.jpg";
const IncidentsFeedCard = () => {
    return (
        <div className="card">
            <div className="card-heading is-bordered d-flex flex-j-between">
                <h4>Latest Near By Incidents</h4>
                <div className="dropdown is-spaced is-neutral is-right">
                    <a href="#" className="momeento-p grey-text">
                        view more
                    </a>
                </div>
            </div>
            <div className="card-body no-padding">
                {/* <!-- Story block --> */}
                <div className="story-block">
                    <div className="img-wrapper">
                        <img src={avatar} data-user-popover="1" alt="" />
                    </div>
                    <div className="story-meta">
                        <span>
                            <a href="#" className="black-text">
                                Dan Walker
                            </a>
                        </span>
                        <span>1 hour ago</span>
                        <p>
                            <i
                                className="icofont icofont-google-map"
                                style={{ color: "red" }}
                            ></i>
                            <span
                                className="momeento-p grey-text"
                                style={{ display: "inline" }}
                            >
                                Sector, Financial Center Street, Dubai, United
                                Arab Emirates
                            </span>
                        </p>
                        <a href="#" className="momeento-p">
                            view more
                        </a>
                    </div>
                </div>
                {/* <!-- Story block --> */}
                <div className="story-block">
                    <div className="img-wrapper">
                        <img src={avatar} data-user-popover="1" alt="" />
                    </div>
                    <div className="story-meta">
                        <span>
                            <a href="#" className="black-text">
                                Dan Walker
                            </a>
                        </span>
                        <span>1 hour ago</span>
                        <p>
                            <i
                                className="icofont icofont-google-map"
                                style={{ color: "red" }}
                            ></i>
                            <span
                                className="momeento-p grey-text"
                                style={{ display: "inline" }}
                            >
                                Sector, Financial Center Street, Dubai, United
                                Arab Emirates
                            </span>
                        </p>
                        <a href="#" className="momeento-p">
                            view more
                        </a>
                    </div>
                </div>
                {/* <!-- Story block --> */}
                <div className="story-block">
                    <div className="img-wrapper">
                        <img src={avatar} data-user-popover="1" alt="" />
                    </div>
                    <div className="story-meta">
                        <span>
                            <a href="#" className="black-text">
                                Dan Walker
                            </a>
                        </span>
                        <span>1 hour ago</span>
                        <p>
                            <i
                                className="icofont icofont-google-map"
                                style={{ color: "red" }}
                            ></i>
                            <span
                                className="momeento-p grey-text"
                                style={{ display: "inline" }}
                            >
                                Sector, Financial Center Street, Dubai, United
                                Arab Emirates
                            </span>
                        </p>
                        <a href="#" className="momeento-p">
                            view more
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncidentsFeedCard;
